export default __webpack_public_path__ + "static/media/basic.45c54206.svg";